import { Dictionary } from '@/dictionary/Dictionary'
import i18n from '@/i18n'

const tariffSortingDitc: Array<Dictionary> = []

enum tariffSortingEnum {
    NONE = 'none',
    ASC = 'asc'
}

for (const code of Object.values(tariffSortingEnum)) {
    tariffSortingDitc.push(
        {
            code,
            name: i18n.t(`dictionary.tariffSorting.${code}`).toString()
        }
    )
}

export { tariffSortingEnum, tariffSortingDitc }
